<template>
  <human-nav current="ch2bet">
    <template #mainContent>
      <nii-show  file-name="ch2bet.nii" container-id="ch2bet"></nii-show>
    </template>
  </human-nav>
</template>

<script>
import HumanNav from "@/components/public/humanNav";
import NiiShow from "@/components/xtk/niiShow";
export default {
  name: "chBet",
  components: {NiiShow, HumanNav}
}
</script>

<style scoped>

</style>